var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElipsisIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.563 3c0-1.172 1.015-2.188 2.187-2.188 1.21 0 2.188 1.016 2.188 2.188 0 1.21-.977 2.188-2.188 2.188-1.172 0-2.188-.977-2.188-2.188zm-6.25 0C6.313 1.828 7.327.812 8.5.812c1.21 0 2.188 1.016 2.188 2.188 0 1.21-.977 2.188-2.188 2.188-1.172 0-2.188-.977-2.188-2.188zM2.25.812C3.46.813 4.438 1.829 4.438 3c0 1.21-.977 2.188-2.188 2.188C1.078 5.188.062 4.21.062 3 .062 1.828 1.078.812 2.25.812z"
  })));
}
export default SvgElipsisIcon;